import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

export const useGenerateMagicLinkMutation = (
  options?: UseMutationOptions<
    { magicLink: string },
    AxiosError,
    { userId: string }
  >
) => {
  return useMutation<{ magicLink: string }, AxiosError, { userId: string }>({
    ...options,
    mutationFn: async ({ userId }) => {
      const res = await httpClient.post(
        `/admin/users/${userId}/generate-magic-link`,
        {
          userId,
        }
      )
      return res.data
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      await navigator.clipboard.writeText(data.magicLink)
      notifications.show({
        autoClose: 10000,
        styles: {
          description: {
            maxHeight: "unset",
            height: "min-content",
            textOverflow: "unset",
          },
        },
        title: `Magic link generated `,
        message: `Magic link generated and copied to clipboard : ${data.magicLink}`,
        color: "blue",
      })
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
      notifications.show({
        title: "Error",
        message: "An error occurred while generating the magic link",
        color: "red",
      })
    },
  })
}
